if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.ajaxCart = document.querySelector('ajax-cart');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      // this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.ajaxCart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
		//console.log(response.variant_title);
        
      
        
          document.getElementById('varinatSKU').innerHTML=`SKU ${response.sku}`;
        document.getElementById('varinatype').innerHTML=`Size ${response.variant_title}`;
       fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { 
    if(document.getElementById('ProductPopup-sizeGuide'))
        {
         document.getElementById('cartNotificationCount').innerHTML=`(${data.item_count})`; 
         document.getElementById('cart-notification').classList.add('notifyshow');
         document.getElementById('noticeOverlay').style.display="block";

        }
      
         
       });
          this.ajaxCart.renderContents(response);
          if(document.getElementById('ProductPopup-sizeGuide')){

            setTimeout(()=>{
       document.querySelector("#cusomajax .ajax__cart").removeAttribute("open");
  	   document.querySelector('body').classList.remove('ajax-cart-open');        
                   
                   }, 100);
          }
       
                
                })
      
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

